import { DpdPickupPudo } from './cart/DpdPickup.js';
import './libs/markerclusterer.js';

declare let google;
declare let MarkerClusterer;

export default class Cart {
    public static update(oncomplete?: () => void): void {
        $('body').trigger('cartUpdate', () => {
            if (oncomplete != null) {
                oncomplete();
            }
        });
    }

    public static setProductQuantity(id: number, quantity: number, oncomplete?: () => void): void {
        $.post('/cartapi/' + id + '/set', {quantity: quantity}, () => {
            if (oncomplete != null) {
                oncomplete();
            }
        });
    }

    public static async onServiceDpdPickup($uid: JQuery) {
        $uid.addClass('service-dpdpickup--loading');

        let $map = $('.service-dpdpickup__map', $uid);
        let $info = $('.service-dpdpickup__info', $uid);
        let $title = $('.lvi .value', $uid);

        let pudo = $uid.data('pudo');

        if (pudo) {
            $title.text(pudo);
        }

        let center = new google.maps.LatLng(52, 19.5);

        var map = new google.maps.Map($map.get(0), {
            center: center,
            zoom: 6,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        });

        try {
            const r = await $.get('/api/dpdpickup/pudos').promise();

            let markerCluster = new MarkerClusterer(map, null, {
                imagePath: '/theme/images/maps/m',
                maxZoom: 12
            });

            let markers = [];

            for (const v of <DpdPickupPudo[]>r.list) {
                let pos = new google.maps.LatLng(v.latitude, v.longitude);

                let marker = new google.maps.Marker({
                    map: map,
                    position: pos,
                    title: v.id,
                });

                google.maps.event.addListener(marker, 'click', async () => {
                    $uid.addClass('service-dpdpickup--loading2');

                    const r = await $.post('/api/dpdpickup/pudo', {
                        service: $uid.data('service'),
                        pudo: v.id,
                    }).promise();

                    const pudo: DpdPickupPudo = r.pudo;

                    $title.text(`${pudo.id}`);
                    $info.html(`${pudo.address}, ${pudo.zipcode} ${pudo.city}`);

                    $uid.removeClass('service-dpdpickup--loading2');
                });

                markers.push(marker);
            }

            markerCluster.addMarkers(markers);

            markerCluster.resetViewport();
            markerCluster.redraw();
        } catch (e) {
            $uid.html(e?.message);
        } finally {
            $uid.removeClass('service-dpdpickup--loading');
        }
    }

    public static onServiceInPost($uid: JQuery): void {
        $uid.addClass('service-inpost--loading');

        let $map = $('.service-inpost__map', $uid);
        let $info = $('.service-inpost__info', $uid);
        let $title = $('.lvi .value', $uid);

        let machine = $uid.data('machine');

        if (machine) {
            $title.text(machine);
        }

        let center = new google.maps.LatLng(52, 19.5);

        var map = new google.maps.Map($map.get(0), {
            center: center,
            zoom: 6,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });

        $.get('/cartapi/getinpostmachines', (r) => {
            if (r.success) {
                let markerCluster = new MarkerClusterer(map, null, {
                    imagePath: '/theme/images/maps/m',
                    maxZoom: 12
                });

                let markers = [];

                $.each(r.list, (ix, v) => {
                    let pos = new google.maps.LatLng(v.lat, v.lng);

                    let marker = new google.maps.Marker({
                        map: map,
                        position: pos,
                        title: v.name
                    });

                    google.maps.event.addListener(marker, 'click', () => {
                        var data={
                            service: $uid.data('service'),
                            name: v.name
                        };

                        $uid.addClass('service-inpost--loading2');

                        $.post('/cartapi/setinpostmachine', data, function() {
                            // $('body').trigger('cartUpdate');

                            $title.text(v.name);
                            $info.html(v.html);

                            $uid.removeClass('service-inpost--loading2');
                        });
                    });

                    markers.push(marker);
                });

                markerCluster.addMarkers(markers);

                markerCluster.resetViewport();
			    markerCluster.redraw();
            } else {
                $uid.html(r.message);
            }

            $uid.removeClass('service-inpost--loading');
        });
    }

    public static onPackagingForm($uid: JQuery): void {
        let $pt = $('.packagingtablelist', $uid);
        let $input = $('.packagingtable__quantity input', $uid);

        $('body').one('cartUpdateInit', () => {
            $(':input', $uid).prop('disable', 'disable');

            (<any> $uid).ajaxLoader();
        });

        $('body').one('cartUpdate', () => {
            (<any> $uid).ajaxUpdate($uid.data('action'));
        });

        let updateHandler = () => {
            $('body').trigger('cartUpdateInit');

            let val = $('.packagingtable :radio:checked', $uid).val();
            let poll = $('.vcartpoll :radio:checked', $uid).val();
            let poll_other = $('.vcartpoll :text', $uid).val();

            let packages = parseInt($input.val());

            let data = {
                group: $pt.data('gid'),
                id: val,

                poll: poll,
                poll_other: poll_other,

                packages: packages
            };

            $.post('/cartapi/services', data, () => {
                $('body').trigger('cartUpdate');
            });
        };

        $(':input', $uid).change((e) => {
           updateHandler();
        });

        let $vcartbutton = $('.vcart__button');
        let $button = $('.cartfooter__buttons .next.button').clone();
        $vcartbutton.empty().append($button);

        (<any> $input).qSpinner({
            onLazySpin: (e) => {
                updateHandler();
            }
        });

        (<any> window).updateElements($uid);
    }
}
